module.exports = __webpack_public_path__ + "img/lock-icon-small.4d39a94d.svg";